import { useQuery } from '@tanstack/react-query';
import { getAllModelProviders } from '../../api';
import { ADMIN_QUERY_KEYS } from '@/features/admin/api/query-keys';

export const useModelProviders = () => {
  return useQuery({
    queryKey: ADMIN_QUERY_KEYS.modelProviders.all,
    queryFn: getAllModelProviders,
  });
};
